export default __webpack_public_path__ + "static/media/salesforce.c8945db4.png";